import clsx from 'clsx';
import analyticsInstance from 'libs/rtzr-commons/modules/marketing/Analytics';
import Link from 'next/link';

export const SectionTitle = ({
  title,
  description,
  linkText,
  href,
  className,
  isDark,
}: {
  title: string;
  description?: string;
  linkText?: string;
  href?: string;
  className?: string;
  isDark?: boolean;
}): JSX.Element => {
  return (
    <div className="text-center">
      <h1
        className={clsx(
          'text-xl font-semibold md:text-[3rem] md:leading-[normal] md:font-bold *:bg-gradient-pink-blue-light *:bg-clip-text *:font-semibold *:md:font-bold *:text-transparent',
          isDark ? 'text-white' : 'text-black-light',
          className
        )}
        dangerouslySetInnerHTML={{ __html: title }}
      />
      {description && (
        <p
          className={clsx(
            'text-sm md:text-xl md:leading-[150%] mt-3.5 md:mt-6',
            isDark ? 'text-white opacity-70' : 'text-black-light'
          )}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      {linkText && (
        <Link href={href} passHref>
          <button
            className="inline-block text-primary font-semibold text-sm md:text-xl md:leading-[150%] mt-3.5 md:mt-2"
            onMouseDown={() => {
              analyticsInstance.logEvent(`click_go_to_page`, {
                page_url: href,
              });
            }}
          >
            {linkText}
          </button>
        </Link>
      )}
    </div>
  );
};
